import { Injectable } from '@angular/core';

import { Row } from '@app/classes/row.class';
import { Filters } from '@app/classes/table.class';
import { environment } from 'environments/environment';
import { Service as ServiceAPI } from '@app/services/api.service';

@Injectable({ providedIn: 'root' })
export class Service {
    private base_url = environment.api;
    private api_type = (environment.api_type == 'php')? '.php' : '';
    private base_endpoint = (environment.api_version == 'v1')? 'notification/application/' : 'notification/';
    
    constructor(
        private ServiceAPI: ServiceAPI,
	) { }

    async get(data: any): Promise<any> { return this.ServiceAPI.fetch(data, this.base_url + this.base_endpoint + ((environment.api_type == 'php')? 'get.php' : data.item_id),  'get'); }
    async save(data: any): Promise<any> { return this.ServiceAPI.fetch(data, this.base_url + this.base_endpoint + ((environment.api_type == 'php')? 'save.php' : ''), 'formdata'); }
    async update(data: any, item_id: any): Promise<any> { return this.ServiceAPI.fetch(data, this.base_url + this.base_endpoint + ((environment.api_type == 'php')? 'save.php' : item_id), 'put'); }
    async getList(data: any): Promise<any> { return this.ServiceAPI.fetch(data, this.base_url + this.base_endpoint + ((environment.api_type === 'php')? 'get_list.php' : ''), 'get'); }
    async getPair(data: any): Promise<any> { return this.ServiceAPI.fetch(data, this.base_url + this.base_endpoint + ((environment.api_type === 'php')? 'get_pair.php' : 'get_pair'), 'get'); }
    async getProfile(data: any): Promise<any> { return this.ServiceAPI.fetch(data, this.base_url + this.base_endpoint + ((environment.api_type == 'php')? 'get_profile.php' : `get_profile/${data.item_id}`),  'get'); }
    async changeActive(data: any): Promise<any> { return this.ServiceAPI.fetch(data, this.base_url + this.base_endpoint + ((environment.api_type == 'php')? 'change_active.php' : `active/${data.item_id}`), 'put'); }
    async changeLocked(data: any): Promise<any> { return this.ServiceAPI.fetch(data, this.base_url + this.base_endpoint + ((environment.api_type == 'php')? 'change_locked.php' : `locked/${data.item_id}`), 'put'); }
    async changeDeleted(data: any): Promise<any> { return this.ServiceAPI.fetch(data, this.base_url + this.base_endpoint + ((environment.api_type == 'php')? 'change_deleted.php' : data.item_id), 'delete'); }
    async downloadListCSV(data: any): Promise<any> { return this.ServiceAPI.fetch(data, this.base_url + this.base_endpoint + ((environment.api_type == 'php')? 'download_list_csv.php' : ''),  'get'); }
    
    async updateStatus(data: any, item_id: any): Promise<any> {return this.ServiceAPI.fetch(data,this.base_url + this.base_endpoint + ((environment.api_type == 'php') ? 'save.php' : `change_status/${item_id}`),'put');}
    async changeRead(item_id: any): Promise<any> { return this.ServiceAPI.fetch({}, this.base_url + this.base_endpoint + ((environment.api_type == 'php')? 'save.php' : `change_read/${item_id}`), 'put'); }
    async saveInBulk(data: any): Promise<any> { return this.ServiceAPI.fetch(data, this.base_url + this.base_endpoint + ((environment.api_type == 'php') ? 'save_in_bulk.php' : 'save_in_bulk'), 'post'); }
}

export interface FiltersNotification extends Filters {
    notification_id?:number;
    user_id?:number;
    title?:string; 
    body?: string;
    params?: string;
    schedule?: string;
    status?: string;
    type?: string;
    kind?: string;
    folio?:string;
    [key: string]: any;
}

export class Notification extends Row {
    constructor(){
        super();
    }

    public override init(){
        super.init();
        this.data = {
        user:{},
        user_data:{},
        notification:{},
            pager:{
                next:0,
                previous:0
            }
        };
    }
}